import React from 'react'
import { useIntl } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import { Message } from './s'

const ContentLanguageSupportMessage = ({ language, tight = false }) => {
    const { formatMessage } = useIntl()

    const {
        locales,
        languages
    } = useI18n()

    if(!language || (language in locales)) {
        return null
    }

    const languageName = languages[language]

    return (
        <Message
            type={!!languageName ? 'info' : 'warning'}
            {...(tight ? { className: 'tight' } : null)}
            message={formatMessage({
                id: !!languageName ?
                    'documents_smart_content_language_partial_support_information' :
                    'documents_smart_content_language_no_support_warning',
                defaultMessage: !!languageName ?
                    'The language rules of {language} are only partially supported by Huma. Certain smart field values will be in English or use English formatting.' :
                    'The selected language is not recognized, and its rules are not supported by Huma. Certain smart field values will be in English or use English formatting.'
            }, { language: <strong>{languageName}</strong> })} />
    )
}

export default ContentLanguageSupportMessage